import { IApp03EpicObserver } from '../types';
import { EntityService } from './EntityService';

export class App03EpicObserverService extends EntityService<IApp03EpicObserver> {
    constructor() {
        super(`/App03EpicObservers`);
    }

}